/**
 * Shop product loader — bundles every JSON in /shop-products at build time.
 *
 * Mirrors the JSON-per-product pattern from the Astro Velocity site (item-pages/).
 * Vite's import.meta.glob picks them up eagerly so the shop grid + detail page
 * stay synchronous.
 */
export interface ShopProductOption {
  id: string;
  label: string;
  price: number;
  blurb?: string;
}

export interface ShopProduct {
  slug: string;
  name: string;
  priceFrom: number;
  image: string;
  tagline?: string;
  description: string;
  popularFor?: string[];
  options: ShopProductOption[];
  sku: string;
}

// eager glob so we get a synchronous map at build time.
const modules = import.meta.glob<ShopProduct>('/shop-products/*.json', {
  eager: true,
  import: 'default',
});

export const SHOP_PRODUCTS: ShopProduct[] = Object.values(modules).sort((a, b) =>
  a.priceFrom - b.priceFrom,
);

export function getProduct(slug: string): ShopProduct | undefined {
  return SHOP_PRODUCTS.find((p) => p.slug === slug);
}

export function formatPrice(amount: number): string {
  return new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    maximumFractionDigits: 0,
  }).format(amount);
}
